import { getAuth } from 'firebase/auth';
// @ts-ignore
import { API_URL } from '@env';

// session-scoped flag
let hasSyncedClaims = false;

/**
 * Call /sync-claims once and mark done.
 */
export async function syncClaims(): Promise<any> {
  if (hasSyncedClaims) return;
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) throw new Error('User not authenticated');

  const token = await user.getIdToken(true);
  const res = await fetch(`${API_URL}/api/auth/sync-claims`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
  if (!res.ok) {
    const err = await res.text();
    throw new Error(err || `sync-claims error: ${res.status}`);
  }

  hasSyncedClaims = true;
  return res.json();
}

/**
 * Wraps any protected call to ensure we've already synced once.
 */
async function callWithAuth(path: string, opts: RequestInit = {}): Promise<any> {
  if (path !== '/api/auth/sync-claims') {
    await syncClaims();
  }

  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) throw new Error('User not authenticated');

  const token = await user.getIdToken(true);
  const res = await fetch(`${API_URL}${path}`, {
    ...opts,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...(opts.headers || {}),
    },
  });

  if (!res.ok) {
    let msg: string;
    const ct = res.headers.get('content-type') || '';
    if (ct.includes('application/json')) {
      const body = await res.json().catch(() => null);
      msg = body?.message ?? `HTTP ${res.status}`;
    } else {
      msg = await res.text();
    }
    throw new Error(msg);
  }

  return res.json();
}

export function getLicenseInfo()      { return callWithAuth('/api/auth/license-info',          { method: 'GET'  }); }
export function upgradeLicense()      { return callWithAuth('/api/auth/upgrade-license',        { method: 'POST' }); }
export function getCreditsBalance()   { return callWithAuth('/api/auth/credits-balance',        { method: 'GET'  }); }
export function buyCreditsCheckout()  { return callWithAuth('/api/auth/buy-credits/checkout',   { method: 'GET'  }); }

/**
 * Reset for next session (on sign-out).
 */
export function resetClaimSync() {
  hasSyncedClaims = false;
}
